// =============================================================
// Configuration API - Pro Distribution
// =============================================================
// Uses Netlify Functions as proxy to Teable API
// =============================================================

export const API_URLS = {
  brands: "/.netlify/functions/get-brands",
  families: "/.netlify/functions/get-families",
  catalogMeta: "/.netlify/functions/get-catalog-meta",
  products: "/.netlify/functions/get-products",
  article: "/.netlify/functions/get-article",
};
